import ApiService from "./api.service";

export const DefectTypesService = {
    query() {
        return ApiService.query("/defect-types/options");
    }
};
